import { theme } from "../../../theme/theme";
const style = {
    bullets: {
        bottom: 0,
        justifyContent: "center",
        position: "absolute",
        width: "100%",
    },
    carousel: {
        flex: 1,
    },
    carouselItem: {
        flex: 1,
    },
    carouselTrack: {
        flex: 1,
        flexDirection: "row",
        height: "100%",
    },
    container: {
        overflow: "hidden",
    },
};
const webStyle = () => {
    const { space3 } = theme();
    return {
        bullets: {
            bottom: space3,
        },
    };
};
/**
 * Static CSS properties shared between slide and fade viewport styles in Carousel.web.tsx.
 */
const viewportBase = {
    marginInline: "auto",
    maxWidth: "100%",
    overflow: "hidden",
    position: "relative",
};
export { style, viewportBase, webStyle };
